<swap-modal [modalId]="modalId" [centered]="true">
  <div class="row m-3">
    <div class="col-12 mb-2">
      <img
        loading="lazy"
        src="assets/icons/close-with-inner-circle.svg"
        alt=""
      />
    </div>
    <div class="col-12 d-flex mb-3">
      <h5 class="modal-title mb-0 fw-bolder" id="exampleModalLabel">
        End Transaction
      </h5>
      <button
        type="button"
        class="closeBtn d-none"
        data-bs-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <img loading="lazy" src="assets/icons/close-icon.svg" alt="" />
      </button>
    </div>
    <div class="col-12 mb-3">
      <p>
        Are you sure you want to cancel transaction? Please note that this
        action cannot be undone.
      </p>
      <div class="d-flex align-items-center gap-2">
        <button (click)="closeBtn.click()" class="btn-confirm fw-700 font-13">
          Cancel
        </button>
        <button
          class="btn-confirm fw-700 font-13 btn-delete"
          (click)="emitEndTransaction.emit(true); closeBtn.click()"
        >
          End Transaction
        </button>
      </div>
    </div>
  </div>
</swap-modal>
